import React from "react";
import classnames from "classnames";
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { bindActionCreators } from 'redux';
import { entityIdentRowActions } from '../../../store/entityIdentRowStore';
import { popupActions } from '../../../store/popupStore';
import { withRouter } from 'react-router';
import { writeErr } from "../../common/logger";
import { Circles } from '../../common/loadingComponent';
import { hasPermission } from "../../../store/apiWrapper";
import { isOnAny, getModeClasses } from '../modeClassesResolver';
import BasicInfoLink from '../../common/basicInfoLink';
import Map from '../../common/mapComponent';
import FoIcon from '../../../img/icons/FyzickaOsoba';
import FpoIcon from '../../../img/icons/FyzickaOsobaPodnikatel';
import PoIcon from '../../../img/icons/PravnickaOsoba';
import HistoryIcon from '../../../img/icons/Historie';
import AddrIcon from '../../../img/icons/Domu';
import { strip } from '../../common/utils';

import '../searchRow.scss';
import { relationsSearchActions } from "../../../store/relationsSearchStore";
import { PngFlag } from "../../common/pngFlag";

class RelationsSearchRow extends React.Component {
    state = {
        expanded: false,
        moreBtnOpen: false
    }

    constructor(props) {
        super(props);

        if (!this.props.s && !this.props.entityId) {
            writeErr('At least one of the \'s\' or \'entityId\' props must be set');
        }
        this.props.s || this.props.ensureEntityInfo(this.props.entityId);
    }

    render() {
        const isLoading = this.props.entityInfos[this.props.entityId] && this.props.entityInfos[this.props.entityId].isRequesting === true;
        const entityInfo = this.props.s || (this.props.entityInfos[this.props.entityId] && this.props.entityInfos[this.props.entityId].result);
        const mode = this.mergeModes(this.props.mode, { names: 'desktop|mobile', buttons: 'desktop|mobile', extraData: 'desktop|mobile', basicLink: 'desktop|mobile' });
        if (isLoading) {
            return <div style={{ minHeight: '30px' }}><Circles /></div>
        } else if (entityInfo) {
            return (
                <div
                    className={classnames('search-results-row', 'non-main-search-results-row', {
                        'with-pointer': (typeof this.props.onResultMouseClicked === 'function') || (typeof this.props.onResultMouseReleased === 'function')
                    })}
                    style={{ padding: "0" }}
                    onMouseDown={(e) => (typeof this.props.onResultMouseClicked === 'function') && this.props.onResultMouseClicked(e, entityInfo)}
                    onMouseUp={(e) => (typeof this.props.onResultMouseReleased === 'function') && this.props.onResultMouseReleased(e, entityInfo)}
                >

                    <div key={entityInfo.entityId} className={`qs-result non-main-sr-result ${entityInfo.isCancelled ? 'qs-result-historical' : ''}`} style={{ flexGrow: 1 }}>
                        {this.renderEntityLine(entityInfo, mode)}
                        {isOnAny(mode.extraData) && (this.props.expandedByDefault || this.state.expanded) && this.renderExtraLine(entityInfo, mode.extraData)}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderEntityLine = (entityInfo, mode) => {
        let batch = [];
        if (mode.extraData) {
            if (entityInfo.type === 2 && entityInfo.dateOfBirth && entityInfo.dateOfBirth.trim()) {
                batch.push(
                    <React.Fragment key="1">
                        {!this.props.condensed && <span><Translate id="Report.NaturalIdentData.DateOfBirth" />: </span>}
                        <span className={entityInfo.entrepreneur ? "qs-result-id-entrepreneur" : null}>{entityInfo.dateOfBirthFormated}</span>
                    </React.Fragment>
                );
            }

            if (entityInfo.type !== 2 && entityInfo.ico && entityInfo.ico.trim()) {
                batch.push(
                    <React.Fragment key="2">
                        {!this.props.condensed && <span><Translate id="Report.CompanyIdentification.Ico" />: </span>}
                        <span className={entityInfo.entrepreneur ? "qs-result-id-entrepreneur" : null}>{ReactHtmlParser(entityInfo.ico)}</span>
                    </React.Fragment>
                );
            }
        }

        if (batch.length > 0)
            batch = [<span key="0">│</span>, ...batch];

        return (
            <div className='entity-line-data non-main-entity-line-data' style={{ display: 'flex', alignItems: 'center', flex: '1 0 auto' }}>
                {this.renderIcon(entityInfo)}
                <div
                    className={classnames(
                        'qs-highlighted-match qs-highlighted-match-ellipsis bold',
                        { 'wrap': this.props.wrapEntityName, 'underline': this.props.quickReportLink && localStorage.locales_url_format === 'underline' }
                    )}
                    title={this.props.queryName}
                >
                    {(isNullOrUndefined(this.props.quickReportLink) || this.props.quickReportLink === true) && hasPermission(null, "SimpleReport")
                        ? <BasicInfoLink entityId={entityInfo.entityId} isAddress={entityInfo.reports.AR} title={strip(entityInfo.name)}>
                            {ReactHtmlParser(entityInfo.name)}
                        </BasicInfoLink>
                        : <React.Fragment>{ReactHtmlParser(entityInfo.name)}</React.Fragment>}
                </div>
                <PngFlag countryCode={entityInfo.country} />
                {isOnAny(mode.extraData) && <div className={`${classnames(getModeClasses(mode.extraData))} search-extra-data`} style={{ margin: 'auto .5em auto .2em', display: 'flex', alignItems: 'center' }}>{batch}</div>}
            </div>
        );
    }

    renderExtraLine = (entityInfo, extraDataMode) => {
        return (
            <div className={classnames(Object.assign({ 'qs-result-2': true }, getModeClasses(extraDataMode)))}>
                {entityInfo.hasHistoricalNames &&
                    <>
                        <HistoryIcon className="search-row-history-icon" style={{ height: '1.5em', width: '1.5em' }} />
                        <span className="qs-historical-names" title={this.getHistoricalNamesString(entityInfo.historyMatch.names, true)}>
                            <span> </span>
                            <Translate id="Search.HistoryNames" />: {ReactHtmlParser(this.getHistoricalNamesString(entityInfo.historyMatch.names))}
                            {entityInfo.address && <span>│</span>}
                        </span>
                    </>
                }
                {entityInfo.address && <span className="qs-address" title={entityInfo.address}>
                    {entityInfo.address}
                    <span onMouseUp={this.props.onMouseReleasedIgnoreEvents}>
                        <Map address={entityInfo.address} id={entityInfo.entityId} />
                    </span>
                </span>}
            </div>
        );
    }

    renderIcon = (entityInfo) => {
        const Icon = entityInfo.type === 1 ? (entityInfo.entrepreneur === true ? FpoIcon : PoIcon) : entityInfo.reports.AR ? AddrIcon : FoIcon;
        return (
            <div className='search-row-type-icon' style={{ padding: '0.425em 0.125em 0.185em 0em' }}>
                <Icon className='icon-centered svg-standard-fill' style={{ height: '1.25em', width: '1.25em' }} />
            </div>
        );
    }

    getHistoricalNamesString = (nameList, removeTags = false) => {
        if (isNullOrUndefined(nameList))
            return "";

        let result = nameList.join("; ");
        return removeTags ? result.replace(/<\/?\s*em>/g, "") : result;
    }

    mergeModes = function (input, def) {
        if (input === null || input === undefined) { return def; }
        const keys = Object.keys(def);
        for (let index = 0; index < keys.length; index++) {
            if (!input.hasOwnProperty(keys[index])) {
                input[keys[index]] = def[keys[index]];
            }
        }
        return input;
    }

    openPortfolioPopup = (subject) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }
}

export default withRouter(withLocalize(connect(
    state => state.entityIdentRow,
    dispatch => bindActionCreators({ ...entityIdentRowActions, ...popupActions, ...relationsSearchActions }, dispatch),
)(RelationsSearchRow)));